import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { showUnitSlice } from '../../features/UnitSlice/ShowUnitSlice';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { motion } from 'framer-motion';
import 'react-lazy-load-image-component/src/effects/blur.css';
import Loading from '../Loading';
import { useTranslation } from 'react-i18next';

function ShowUnit() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const { unit, loading } = useSelector((state) => state.showUnit);
  const { t,i18n } = useTranslation();

  useEffect(() => {
    dispatch(showUnitSlice({ id }));
  }, [id, dispatch,i18n.language]);

  const getExperienceYears = (date) => {
    const getDate = new Date(date);
    return new Date().getFullYear() - getDate.getFullYear();
  };

  if (loading || !unit) return <Loading />;

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-5xl mx-auto bg-white rounded-2xl shadow-xl overflow-hidden">
        <div className="bg-gradient-to-r from-[#07A024] to-[#05801C] p-8">
          <h1 className="text-4xl font-bold text-white">{unit.title}</h1>
          <div className="h-1 w-16 bg-white/30 mt-4 rounded-full"></div>
        </div>

        <div className="p-6 space-y-6">
          {/* <h2 className="text-2xl font-semibold text-gray-800">{t("Members")}</h2> */}

          <div className="grid md:grid-cols-2 gap-6">
            {unit.members?.map((member) => (
              <motion.div
                key={member.id}
                whileHover={{ scale: 1.02 }}
                className="flex items-center gap-4 p-4 rounded-xl bg-gray-50 hover:bg-white transition-all shadow"
              >
                <LazyLoadImage
                  src={process.env.REACT_APP_IMG_URL + member.image}
                  effect="blur"
                  className="w-20 h-20 rounded-2xl object-cover border-4 border-white shadow-lg"
                  alt={member.name}
                />

                <div className="flex-1">
                  <h3 className="text-xl font-semibold text-gray-900">{member.name}</h3>
                  <p className="text-gray-600">
                    {getExperienceYears(member.date)} {t("YearExp")}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ShowUnit;
